import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import { ActionEnum } from '../enums/ActionEnum';
import { ENVIRONMENT_CONFIG } from '../constants/environmentConfig';

type Methods = 'get' | 'post' | 'delete' | 'put' | 'patch';

const serverURL = import.meta.env.CONSUMER_PRICE_SERVICE;
// const token = localStorage.getItem('token')

export const getLanguage = (): string => {
  if (!ENVIRONMENT_CONFIG.DISPLAY_TRANSLATIONS) {
    return ENVIRONMENT_CONFIG.DEFAULT_LAN;
  }
  return localStorage.getItem('i18nextLng') ?? ENVIRONMENT_CONFIG.DEFAULT_LAN;
};

export interface FetcherResponse {
  statusText: 'SUCCESS' | 'ERROR' | 'UNKOWN' | 'ERROR';
  data?: any;
  status: number;
  response: AxiosResponse;
  message?: string;
  errors?: any;
}

const send = (
  method: Methods,
  path: string,
  data?: any,
  config?: AxiosRequestConfig,
  extraUrl?: string,
  action?: ActionEnum
): Promise<FetcherResponse> => {
  return new Promise((resolve, reject) => {
    const url = `${extraUrl ? extraUrl : serverURL}/${path}`;
    const headers: any = {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      'Accept-Language': getLanguage(),
    };

    axios({
      method,
      url,
      data,
      headers,
      ...config,
    })
      .then((response: AxiosResponse) => {
        if (response.status) {
          if (response.status === 200 || response.status === 201) {
            resolve({
              status: response.status,
              data: response.data,
              response: response,
              statusText: 'SUCCESS',
              message: response.data.message,
            });
          } else if (response.status === 422) {
            reject({
              status: response.status,
              data: response.data?.data,
              statusText: 'ERROR',
              response: response,
              message: response.data.message,
              errors: response.data?.errors,
            });
          }
        } else {
          reject({
            status: 500,
            statusText: 'UNKNOWN',
            message: 'System error',
          });
        }
      })
      .catch((e: any) => {
        if (e.response) {
          if (e.response.status) {
            if (e.response.data.message === 'jwt expired') {
              localStorage.removeItem('token');
              window.location.reload();
            } else if (e.response.data.statusCode === 401) {
              localStorage.setItem('path', url);
              if (action !== ActionEnum.NO_REDIRECT) window.location.href = '/logout';
            }

            reject({
              status: e.response.status,
              statusText: 'ERROR',
              errors: e.response.data?.errors,
              message: e.response.data.message,
              details: e?.response?.data?.details
            });
          } else {
            reject({
              statusText: 'ERROR',
              message: 'System error',
            });
          }
        } else {
          reject({
            statusText: 'ERROR',
            message: 'Network error',
          });
        }
      });
  });
};

const post = (
  path: string,
  data?: any,
  config?: AxiosRequestConfig,
  extraUrl?: string,
  action?: ActionEnum
) => {
  return send('post', path, data, config, extraUrl, action);
};

const put = (path: string, data?: any, config?: AxiosRequestConfig, extraUrl?: string) => {
  return send('put', path, data, config, extraUrl);
};

const get = (path: string, data?: any, config?: AxiosRequestConfig, extraUrl?: string) => {
  if (data) {
    // Use axios params to handle arrays properly
    const axiosConfig = {
      ...config,
      params: data,
    };
    return send('get', path, undefined, axiosConfig, extraUrl);
  }
  return send('get', `${path}`, data, config, extraUrl);
};

const patch = (path: string, data?: any, config?: AxiosRequestConfig, extraUrl?: string) => {
  return send('patch', path, data, config, extraUrl);
};

const del = (path: string, data?: any, config?: AxiosRequestConfig, extraUrl?: string) => {
  return send('delete', path, data, config, extraUrl);
};

const fetcher = {
  get,
  post,
  put,
  del,
  patch,
};

export default fetcher;
